export var E_SELECT_SHORTCUTS;
(function (E_SELECT_SHORTCUTS) {
    E_SELECT_SHORTCUTS[E_SELECT_SHORTCUTS["ALL"] = 0] = "ALL";
    E_SELECT_SHORTCUTS[E_SELECT_SHORTCUTS["NONE"] = 1] = "NONE";
    E_SELECT_SHORTCUTS[E_SELECT_SHORTCUTS["DEFAULT"] = 2] = "DEFAULT";
})(E_SELECT_SHORTCUTS || (E_SELECT_SHORTCUTS = {}));
export var IDENTIFIER_SELECT = 'select';
export var IDENTIFIER_SELECT_CATEGORY_LABEL = 'select-category-label';
export var IDENTIFIER_SELECT_VALUE_SELECTED = 'select-value-selected';
export var IDENTIFIER_SELECT_OPTIONS = 'select-options';
export var IDENTIFIER_SELECT_OPTION_SHORTCUT = 'select-option-shortcut';
export var IDENTIFIER_SELECT_OPTION_ITEM = 'select-option-item';
export var IDENTIFIER_SELECT_ERROR = 'select-error';
